import { ROUTES } from "@/config/types";
import { setNavigation } from "@/store/slices/appSlice";
import { store } from "@/store/store";
import { useCallback, useEffect, useState } from "react"
import logo from '../assets/images/darperso-blue.svg';
import { navigateTo } from "@/utils/utils";

export const handlePageChange = () => {
    window.scroll({
        top: 0,
        behavior: "smooth",
    });
}

const NavigationItem = ({ label = '', route = '', isDesktop = true, onClick = undefined }) => {
    if (isDesktop) {
        return <a onClick={(e) => {
            navigateTo(e, route)
            onClick?.();
        }} href={route} className="navigation-item pointer">
            <div className="text-white nav-label ">{label}</div>
            <div className="line bg-white"></div>
        </a>
    } else {
        return <div className="py-3 ">
            <a onClick={(e) => {
            navigateTo(e, route)
            onClick?.();
        }} href={route} className="text-white fw-bold fs-30 py-3 pointer">
            <div className="text-white nav-label ">{label}</div>
            <div className="line bg-white"></div>
        </a>
        </div>
    }
}

export const Navigation = () => {

    const [toggleNavbar, setToggleNavbar] = useState(false)

    const [isBurgerOpen, setIsBurgerOpen] = useState(false)
    const toggleNavbarHandler = () => {
        const scrolled = window.scrollY

        if (scrolled > 60) {
            setToggleNavbar(true);
        } else if (scrolled <= 60) {
            setToggleNavbar(false);
        }
    };


    useEffect(() => {
        window.addEventListener('scroll', toggleNavbarHandler, true);
        // Remove the event listener
        return () => {
            window.removeEventListener('scroll', toggleNavbarHandler, true);
        };
    }, []);

    const closeBurgerMenu = useCallback(() => { setIsBurgerOpen(false) }, [])
    return (
        <>
            <div className={`mobile-menu ${isBurgerOpen ? ' open ' : ''}`} >
                <div className="menu-wrapper  flex-column d-flex h-100 align-items-start align-items-sm-center justify-content-start justify-content-sm-center">
                    <NavigationItem isDesktop={false} label="Home" route={ROUTES.HOME} onClick={closeBurgerMenu} />
                    <NavigationItem isDesktop={false} label="About" route={ROUTES.ABOUT} onClick={closeBurgerMenu} />
                    <div className="text-white fw-bold fs-30 my-3 " >Services
                        <div className="pl-3 pt-3">
                            <NavigationItem route={ROUTES.WEB_SOLUTIONS} label="Web Development" onClick={closeBurgerMenu} isDesktop={false} />
                            <NavigationItem route={ROUTES.MOBILE_APP_SOLUTIONS} label="Mobile App Solutions" onClick={closeBurgerMenu} isDesktop={false} />
                            <NavigationItem route={ROUTES.ECOMMERCE_SOLUTIONS} label="Ecommerce Solutions" onClick={closeBurgerMenu} isDesktop={false} />
                            <NavigationItem route={ROUTES.TAILORED_SOFTWARE_SOLUTIONS} label="Tailored Software Solutions" onClick={closeBurgerMenu} isDesktop={false} />
                        </div>
                    </div>
                    <NavigationItem isDesktop={false} label="Contact" route={ROUTES.CONTACT} onClick={closeBurgerMenu} />
                </div>
            </div>
            <div className={` py-3 top-navigation ${toggleNavbar ? ' scrolled ' : ''}`}>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-3 col-6">
                            <img src={logo} alt="" className="logo" onClick={(e) => {
                                store.dispatch(setNavigation(ROUTES.HOME))
                            }} />
                        </div>
                        <div className="col-lg-6 d-none d-lg-block">
                            <div className="navigation-items">
                                <NavigationItem route={ROUTES.HOME} label="Home" />
                                <NavigationItem route={ROUTES.ABOUT} label="About" />
                                <div className="navigation-item pointer dropdown-wrapper" >
                                    <div className="text-white nav-label ">Services</div>
                                    <div className="line bg-white"></div>
                                    <div className="dropdown-container">
                                        <NavigationItem route={ROUTES.WEB_SOLUTIONS} label="Web Solutions" />
                                        <NavigationItem route={ROUTES.MOBILE_APP_SOLUTIONS} label="Mobile App Solutions" />
                                        <NavigationItem route={ROUTES.ECOMMERCE_SOLUTIONS} label="Ecommerce Solutions" />
                                        <NavigationItem route={ROUTES.TAILORED_SOFTWARE_SOLUTIONS} label="Tailored Software Solutions" />
                                    </div>
                                </div>
                                <NavigationItem route={ROUTES.CONTACT} label="Contact" />

                            </div>
                        </div>

                        <div className="col-lg-4 col-6 text-right  d-block d-lg-none">
                            <div className={`burger-menu ml-auto ${isBurgerOpen ? ' open ' : ''}`} onClick={() => {
                                setIsBurgerOpen(p => !p)
                            }}>
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>

    )
}